(function(angular){
	'use strict';

	angular
		.module('affixRevealModule')
		.directive('affixReveal', [
			'$window',
			'BREAKPOINTS',
			'RevealService',
			'STATIC_BASE_PATH',
			affixRevealFunction
		]);

	function affixRevealFunction(
		$window,
		BREAKPOINTS,
		RevealService,
		STATIC_BASE_PATH) {
		return {
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/shared/affix-reveal/affix-reveal.html',
			restrict: 'E',
			replace: true,
			transclude: true,
			scope: {
				elementHeight: '@',
				startElement: '@'
			},
			link: function($scope, $element, $attrs) {
				var startElement, thisElement, originalPosition, startPosition;

				if($window.innerWidth >= BREAKPOINTS.LG_START) {
					startElement = angular.element($window.document.getElementById($scope.startElement))[0];
					thisElement = $element[0];					
					startPosition = startElement.getBoundingClientRect().top + $window.innerHeight;
					originalPosition = thisElement.getBoundingClientRect().bottom + 136;
					angular.element($window).on('load scroll', updateAffixRevealElement);
				} else {
					$scope.originalElementVisible = true;
				}

				function updateAffixRevealElement() {
					var scrollDepth = $window.pageYOffset + $window.innerHeight;

					if(scrollDepth >= originalPosition) {
						$scope.$apply(function() {
							$scope.affixElement = false;
							$scope.originalElementVisible = true;
						});
					} else {
						if(scrollDepth < startPosition) {
							$scope.$apply(function() {
								$scope.affixElement = false;
								$scope.originalElementVisible = false;
							});
						} else {
							$scope.$apply(function() {
								$scope.affixElement = true;	
								$scope.originalElementVisible = false;
							});
						}
					}
				}
			}
		};
	}
})(window.angular);